import { createApiClient } from '@hirebridge/api-client'

const baseUrl =
  import.meta.env.VITE_API_URL ??
  import.meta.env.VITE_API_BASE_URL ??
  'http://localhost:8000/api/v1'

let activeCompanyId: number | null = null

export const setActiveCompany = (id: number | null) => {
  activeCompanyId = id
  if (id) localStorage.setItem('company_id', String(id))
  else localStorage.removeItem('company_id')
}

const stored = localStorage.getItem('company_id')
if (stored) activeCompanyId = Number(stored)

/**
 * Web authentication is by session cookie, so `getToken` returns null and the
 * client relies on `credentials: include`. Nothing sensitive is kept in
 * localStorage — a token there is readable by any injected script (§19).
 */
export const api = createApiClient({
  baseUrl,
  getToken: () => null,
  getCompanyId: () => activeCompanyId,
  onUnauthenticated: () => {
    if (!window.location.pathname.startsWith('/login')) {
      window.location.href = '/login'
    }
  },
})

/** Sanctum requires a CSRF cookie before the first stateful write. */
export const primeCsrf = async () => {
  const origin = baseUrl.replace(/\/api\/v1\/?$/, '')
  await fetch(`${origin}/sanctum/csrf-cookie`, { credentials: 'include' })
}